// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_6eb00b8e53--checkbox--avY4t","box":"_6eb00b8e53--box--3j1de","invalid":"_6eb00b8e53--invalid--1nbLc","disabled":"_6eb00b8e53--disabled--2gO72"};